'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import growingLibraryBackground from '@/public/images/viverse-plus/growing-library-background.png';
import studioBedtimeDigitalGames from '@/public/images/viverse-plus/studio-bedtime-digital-games.png';
import studioFamobi from '@/public/images/viverse-plus/studio-famobi.png';
import studioMirraGames from '@/public/images/viverse-plus/studio-mirra-games.png';
import studioPlugInDigital from '@/public/images/viverse-plus/studio-plug-in-digital.png';
import studioSamsung from '@/public/images/viverse-plus/studio-samsung-gulf-electronics.png';
const studios = [{
  key: 'samsung',
  image: studioSamsung
}, {
  key: 'bedtime-digital-games',
  image: studioBedtimeDigitalGames
}, {
  key: 'famobi',
  image: studioFamobi
}, {
  key: 'mirra-games',
  image: studioMirraGames
}, {
  key: 'plug-in-digital',
  image: studioPlugInDigital
}] as const;
export default function GrowingLibrarySection() {
  const $ = _c(44);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none absolute inset-0"><Image src={growingLibraryBackground} alt="" fill={true} sizes="100vw" className="object-cover object-[15%_30%]" /><div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(18,18,22,0)_0%,#121216_82%)]" /><div className="absolute inset-0 bg-[#121216]/[0.29]" /><div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(18,18,22,0)_0%,#1b1b1f_100%)]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 16
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true,
      amount: 0.2
    };
    t4 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("plus.growing-library.eyebrow");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <p className="text-vive-primary-40 text-xs leading-4 font-extrabold tracking-[6.15px] uppercase">{t5}</p>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("plus.growing-library.title");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <h2 className="mt-5 text-center text-3xl leading-10 font-extrabold tracking-[0.15px] text-[#eeeef0] sm:text-[38px]">{t7}</h2>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("plus.growing-library.description");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <p className="text-vive-primary-30 mt-4 max-w-[480px] text-center text-[15px] leading-[26px]">{t9}</p>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6 || $[19] !== t8) {
    t11 = <motion.div className="flex flex-col items-center" initial={t1} whileInView={t2} viewport={t3} transition={t4}>{t6}{t8}{t10}</motion.div>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = studios.map((studio, index) => <motion.div key={studio.key} className="flex flex-col items-center rounded-2xl border-2 border-white/6 bg-black/15 px-5 py-7 text-center backdrop-blur-md lg:col-span-2 lg:nth-4:col-start-2" initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: "easeOut",
      delay: (index + 1) * 0.12
    }}><Image src={studio.image} alt="" width={48} height={48} className="rounded-full object-cover" /><p className="mt-2.5 text-sm leading-[22px] font-semibold tracking-[0.15px] text-[#eeeef0]">{t(`plus.growing-library.studios.${studio.key}.name`)}</p><p className="text-vive-primary-30 mt-2.5 text-[11.6px] leading-[18.6px]">{t(`plus.growing-library.studios.${studio.key}.description`)}</p></motion.div>);
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <div className="mt-12 grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-6">{t12}</div>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      opacity: 0,
      y: 16
    };
    t15 = {
      opacity: 1,
      y: 0
    };
    t16 = {
      once: true,
      amount: 0.2
    };
    t17 = {
      duration: 0.6,
      ease: "easeOut",
      delay: 0.6
    };
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t14 = $[25];
    t15 = $[26];
    t16 = $[27];
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t) {
    t18 = t("plus.growing-library.footnote.line1");
    $[29] = t;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18) {
    t19 = <p className="text-vive-primary-30 text-center text-[15px] leading-[26px]">{t18}</p>;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t) {
    t20 = t("plus.growing-library.footnote.line2");
    $[33] = t;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t20) {
    t21 = <p className="text-vive-primary-30 text-center text-[15px] leading-[26px]">{t20}</p>;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t19 || $[38] !== t21) {
    t22 = <motion.div className="mt-10 max-w-[1128px]" initial={t14} whileInView={t15} viewport={t16} transition={t17}>{t19}{t21}</motion.div>;
    $[37] = t19;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t11 || $[41] !== t13 || $[42] !== t22) {
    t23 = <div className="relative overflow-hidden px-6 pt-14 pb-16 sm:px-12 sm:pt-20">{t0}<div className="relative mx-auto flex max-w-[1128px] flex-col items-center">{t11}{t13}{t22}</div></div>;
    $[40] = t11;
    $[41] = t13;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  return t23;
}